module.exports = __webpack_public_path__ + "img/sa_2.f525d1e4.png";